export const API_BASE_URL = "https://careers.mtn.co.rw";